import {
  describeAgeCondition,
  resolveRange,
  type ReferenceRanges,
} from '@/shared/utils/referenceRangeRules';

/**
 * The caveat shown under the normal band when the range is age-specific but
 * the patient's age is unknown or outside every block, so the baseline block
 * is in use (see referenceRangeRules). null when the band is exact.
 */
export function ageFallbackNote(
  referenceRanges: ReferenceRanges | undefined,
  sex: string | null | undefined,
  age?: number | null
): string | null {
  const { ageFallback } = resolveRange(referenceRanges, sex, age);
  if (!ageFallback) return null;
  const shown = describeAgeCondition(ageFallback);
  return age === null || age === undefined
    ? `Age-dependent range. Patient age unknown; showing ages ${shown}.`
    : `Age-dependent range. No band for age ${age}; showing ages ${shown}.`;
}
